'use strict';

var jsonFile = '2048.json';

/*eslint-disable*/

window.fakeStorage = {
	_data: {},

	setItem: function ( id, val ) {
		return this._data[id] = String(val);
	},

	getItem: function ( id ) {
		return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
	},

	removeItem: function ( id ) {
		return delete this._data[id];
	},

	clear: function () {
		return this._data = {};
	}
};

function LocalStorageManager () {
	this.bestScoreKey = "bestScore";
	this.gameStateKey = "gameState";

	this.real = this.localStorageSupported();
	this.storage = this.real || window.fakeStorage;
}

LocalStorageManager.prototype.localStorageSupported = function () {
	var testKey = "test";
	var storage = window.top.stbStorage || window.localStorage || window.top.localStorage;

	try {
		storage.setItem(testKey, "1");
		storage.removeItem(testKey);
		return storage;
	} catch ( error ) {
		return false;
	}
};

// Best score getters/setters
LocalStorageManager.prototype.getBestScore = function () {
	return this.storage.getItem(this.bestScoreKey) || 0;
};

LocalStorageManager.prototype.setBestScore = function ( score ) {
	this.storage.setItem(this.bestScoreKey, score);
};

// Game state getters/setters and clearing
LocalStorageManager.prototype.getGameState = function () {
	if ( !this.real ) {
		debug.log('Restore last game state from storage');
		return this._getGameState();

	} else {
		var stateJSON = this.storage.getItem(this.gameStateKey);
		return stateJSON ? JSON.parse(stateJSON) : null;
	}
};

LocalStorageManager.prototype.setGameState = function ( gameState ) {
	this.storage.setItem(this.gameStateKey, JSON.stringify(gameState));
};

LocalStorageManager.prototype.clearGameState = function () {
	if ( this.real ) {
		this.storage.removeItem(this.gameStateKey);
	} else {
		this._clearGameState();
	}

};


LocalStorageManager.prototype._saveSate = function ( gameState ) {
	window.top.gSTB.SaveUserData(jsonFile, JSON.stringify({
		game: gameState,
		best: this.storage.getItem(this.bestScoreKey)
	}));
};

LocalStorageManager.prototype._clearGameState = function () {
	window.top.gSTB.SaveUserData(jsonFile, JSON.stringify({
		best: this.storage.getItem(this.bestScoreKey)
	}));
};

LocalStorageManager.prototype._getGameState = function () {
	var result = window.top.gSTB.LoadUserData(jsonFile);

	try {
		result = JSON.parse(result);
		if ( result && result.best ) {
			this.setBestScore(result.best);
		}
		if ( result && result.game ) {
			result = result.game;
		} else {
			result = null;
		}
	} catch ( e ) {
		result = null;
	}
	return result;
};

module.exports = LocalStorageManager;
